export const isOptionSelected = ({ selector, parentName, childName }) => {
  return parentName === selector.parentName && childName === selector.childName;
};
